module.exports = __webpack_public_path__ + "static/media/img_br_video02.76be939b.jpg";